'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	children: _propTypes2.default.node,
	disabled: _propTypes2.default.bool,
	iconStyle: _propTypes2.default.object,
	iconClassName: _propTypes2.default.string,
	onClick: _propTypes2.default.func,
	onBlur: _propTypes2.default.func,
	onFocus: _propTypes2.default.func,
	onKeyboardFocus: _propTypes2.default.func,
	onMouseEnter: _propTypes2.default.func,
	onMouseLeave: _propTypes2.default.func,
	onMouseOut: _propTypes2.default.func,
	tooltip: _propTypes2.default.node,
	tooltipStyles: _propTypes2.default.object,
	tooltipPosition: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	touch: _propTypes2.default.bool,
	style: _propTypes2.default.object
};

var WMIconButton = function WMIconButton(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_IconButton2.default, props)
	);
};

exports.default = WMIconButton;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMIconButton/index.js